module.exports = __webpack_public_path__ + "static/img/4.d22afdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/4.png
// module id = YU8A
// module chunks = 0